"use client";
import { Suspense } from "react";
import { Stack } from "@mui/material";

import { useStore, observer } from "../../service/mobx";
import Search from "../../component/Search";
import Filters from "./Filters";

function Input({ query }) {
  const { bottomSheet, layout } = useStore();

  return (
    <Stack
      pt={3}
      pb={2}
      spacing={3}
      zIndex={1}
      position="sticky"
      bgcolor={
        bottomSheet.open && bottomSheet.expanded === false
          ? "var(--surface-container-highest)"
          : "var(--surface-container-lowest)"
      }
      top={{
        compact: -16,
        expanded: layout.isFullScreen ? 64 : 48,
        extraLarge: layout.isFullScreen ? 0 : undefined
      }}
    >
      <Suspense>
        <Search />
      </Suspense>
      <Filters query={query} />
    </Stack>
  );
}

export default observer(Input);
